import * as admin from "firebase-admin";

import getConfig from "next/config";

import isBrowser from "@sentrei/common/utils/isBrowser";
import isDev from "@sentrei/common/utils/isDev";

const {serverRuntimeConfig} = getConfig();

if (!admin.apps.length && !isBrowser()) {
  if (isDev()) {
    admin.initializeApp({
      credential: admin.credential.cert({
        projectId: process.env.FIREBASE_PROJECT_ID,
        clientEmail: process.env.FIREBASE_CLIENT_EMAIL,
        privateKey: process.env.FIREBASE_PRIVATE_KEY,
      }),
      databaseURL: process.env.FIREBASE_DATABASE_URL,
    });
  } else {
    admin.initializeApp({
      credential: admin.credential.cert({
        projectId: process.env.FIREBASE_PROJECT_ID,
        clientEmail: serverRuntimeConfig.FIREBASE_CLIENT_EMAIL,
        privateKey: serverRuntimeConfig.FIREBASE_PRIVATE_KEY.replace(
          /\\n/g,
          "\n",
        ),
      }),
      databaseURL: process.env.FIREBASE_DATABASE_URL,
    });
  }
}

export const adminStorage = admin.storage();

export const adminDb = admin.firestore();
